import { SxProps } from '@mui/material';

export const DefaultTextSx: SxProps = {
  fontSize: '16px',
  fontWeight: '600',
  lineHeight: '17px',
};
